import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fee-impact',
  component: () => import('../../routes/FeeImpact.svelte'),
  card: {
    id: 'fee-impact',
    title: 'Investment Fee Impact',
    description: 'See how expense ratios silently erode your portfolio. Compare two fee levels and discover the long-term cost of higher investment fees.',
    icon: 'analytics',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/fee-impact',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Investment Fee Impact Calculator – Expense Ratio Comparison Tool',
    description: 'Free investment fee impact calculator. Compare two expense ratios side by side and see how fees drag on your portfolio growth over time. Visualize the long-term cost of higher investment fees with year-by-year breakdowns.',
  },
};

export default meta;
